import React from 'react';
import './AppTable.css';

// Tag to icon mapping
const TAG_ICONS = {
    python: 'https://www.opstool.com/static/icons/python.svg',
    'c++': 'https://www.opstool.com/static/icons/cplusplus.svg',
    git: 'https://www.opstool.com/static/icons/git.svg',
    linux: 'https://www.opstool.com/static/icons/linux.svg',
    shell: 'https://www.opstool.com/static/icons/shell.svg',
    golang: 'https://www.opstool.com/static/icons/golang.svg',
    rust: 'https://www.opstool.com/static/icons/rust.svg',
    ai: 'https://www.opstool.com/static/icons/ai.svg',
    default: 'https://www.opstool.com/static/icons/default.svg'
};

class AppTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNum: 1,
            openSearch: false,
            searchText: '',
            datas: [],  // Initialize datas as empty array
            isLoading: true,  // Add loading state
            error: null  // Add error state
        }

        this.per_page_count = 16;

        this.headerSearchClick = this.headerSearchClick.bind(this);
        this.searchClick = this.searchClick.bind(this);
        this.searchEnter = this.searchEnter.bind(this);
    }

    componentDidMount() {
        // Fetch data when component mounts
        this.fetchData();
    }

    async fetchData() {
        try {
            const response = await fetch('https://www.opstool.com/index.json');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            this.setState({
                datas: data,
                isLoading: false
            });
        } catch (error) {
            this.setState({
                error: error.message,
                isLoading: false
            });
        }
    }

    pageClick(num) {
        this.setState(prevState => ({
            pageNum: num,
            openSearch: prevState.openSearch,
            searchText: prevState.searchText
        }));
    }

    headerSearchClick(e) {
        this.setState(prevState => ({
            openSearch: !prevState.openSearch,
            searchText: ''
        }));
    }

    doSearch() {
        const searchText = document.getElementById('search_input').value;
        this.setState({
            pageNum: 1,
            searchText: searchText
        });
    }

    searchClick(e) {
        this.doSearch();
    }

    searchEnter(e) {
        if (e.key === 'Enter') {
            this.doSearch();
        }
    }

    getTagIcon(tags) {
        if (!tags) return TAG_ICONS.default;
        const firstTag = tags.toLowerCase().split(' ')[0].trim();
        // 兼容 c++/cplusplus
        if (firstTag === 'cplusplus' || firstTag === 'c++') return TAG_ICONS['c++'];
        return TAG_ICONS[firstTag] || TAG_ICONS.default;
    }

    render() {
        const { isLoading, error, datas, openSearch, searchText, pageNum } = this.state;
        
        // Filter data based on search text
        let filteredDatas = [];
        if (searchText.trim() !== '' && openSearch) {
            const searchWords = searchText.toLowerCase().split(' ');
            
            filteredDatas = datas.filter(item => {
                const targetText = (item.title.toLowerCase() + ' ' + item.tags.toLowerCase());
                return searchWords.every(word => targetText.includes(word));
            });
        } else {
            filteredDatas = datas;
        }

        // Handle loading and error states
        if (isLoading) {
            return <div>Loading...</div>;
        }

        if (error) {
            return <div>Error: {error}</div>;
        }

        // Create search row if needed
        const searchRow = (
            <tr key='search_row'>
                <td colSpan='4'>
                    <input type='text' id='search_input' autoComplete="off" onKeyDown={this.searchEnter} />
                    {' '}
                    <input type="submit" value="搜索" id="search_button" onClick={this.searchClick} />
                </td>
            </tr>
        );

        // Create table rows
        const rows = [];
        if (openSearch) {
            rows.push(searchRow);
        }

        const startIndex = this.per_page_count * (pageNum - 1);
        const endIndex = startIndex + this.per_page_count;
        const currentPageData = filteredDatas.slice(startIndex, endIndex);

        currentPageData.forEach((item, i) => {
            rows.push(
                <tr className='hovers' key={i}>
                    <td>
                        <img 
                            alt='' 
                            style={{ marginTop: '4px' }} 
                            height='18' 
                            width='18' 
                            src={this.getTagIcon(item.tags)}
                        /> 
                        <a 
                            style={{ fontSize: '1.1em' }} 
                            href={`#blog/article/${item.pid}`}
                        >
                            {' '}{item.title}
                        </a>
                    </td>
                    <td>{item.tags}</td>
                    <td style={{ textAlign: 'center' }}>{item.update_time}</td>
                </tr>
            );
        });

        // Create pagination
        const total_page_count = Math.ceil(filteredDatas.length / this.per_page_count);
        const cur_page_num = pageNum;
        let pre_hidden_show = false;
        let post_hidden_show = false;
        const pages = [];

        // Previous button
        if (cur_page_num === 1) {
            pages.push(<span key='prev_empty' className="pager pageempty">上一页</span>);
        } else {
            pages.push(
                <a 
                    key='prev_link' 
                    className="pager" 
                    style={{ cursor: 'pointer' }} 
                    onClick={() => this.pageClick(cur_page_num - 1)}
                >
                    上一页
                </a>
            );
        }

        // Page numbers
        for (let i = 1; i <= total_page_count; i++) {
            if (i === cur_page_num) {
                pages.push(<a key={i} className="pager" id="pageselect">{i}</a>);
            } else if ((cur_page_num - i >= 3) && !pre_hidden_show) {
                pages.push(<span key={`pre_${i}`} className="pager pageempty">...</span>);
                pre_hidden_show = true;
            } else if ((i - cur_page_num >= 3) && !post_hidden_show) {
                pages.push(<span key={`post_${i}`} className="pager pageempty">...</span>);
                post_hidden_show = true;
            } else if (Math.abs(i - cur_page_num) < 3) {
                pages.push(
                    <a 
                        key={i} 
                        className="pager" 
                        style={{ cursor: 'pointer' }} 
                        onClick={() => this.pageClick(i)}
                    >
                        {i}
                    </a>
                );
            }
        }

        // Next button and no content message
        if (total_page_count === 0) {
            pages.push(<span key='no_content' className="pager pageempty">无数据</span>);
        }
        if (cur_page_num === total_page_count || total_page_count === 0) {
            pages.push(<span key='next_empty' className="pager pageempty">下一页</span>);
        } else {
            pages.push(
                <a 
                    key='next_link' 
                    className="pager" 
                    style={{ cursor: 'pointer' }} 
                    onClick={() => this.pageClick(cur_page_num + 1)}
                >
                    下一页
                </a>
            );
        }

        return (
            <table id='mytable'>
                <thead>
                    <tr>
                        <td style={{ width: '50%' }}>
                            标题
                            <span 
                                style={{ float: 'right', color: '#888', cursor: 'pointer' }} 
                                onClick={this.headerSearchClick}
                            >
                                Ⓢ
                            </span>
                        </td>
                        <td style={{ width: '30%' }}>标签</td>
                        <td style={{ width: '20%' }}>更新时间</td>
                    </tr>
                </thead>
                <tbody>
                    {rows}
                </tbody>
                <tfoot>
                    <tr style={{ width: '100%' }}>
                        <td colSpan='4' id='pagelist'>
                            <span style={{ float: 'right' }}>
                                {pages}
                            </span>
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    }
}

export default AppTable;